module.exports = __webpack_public_path__ + "h5/img/ting.3558c5cc.jpg";